import { buildQuery } from '@/lib/helper';
import '../lib/typedef';
import client from '../lib/http-client';

const endpoint = '/wallet-stash';

export default {
	/**
	 * Get Balance
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getTotal(cb, errorCb, params = {}) {
		const query = buildQuery(params);
		const url = `${endpoint}/total?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get Histories
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.category] Category Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getList(params, cb, errorCb) {
		const url = endpoint;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
